// noinspection HtmlUnknownTarget

import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import * as customerApi from '@api/customer/customer'
import { AuthorizeContext } from '@context/AuthorizeState'
import * as S from './Navbar.styled'
import GeoSmall from '../Icons/GeoSmall'
import ModalAuthorize from '../Account/ModalAouthorize/ModalAuthorize'
import { useCityById } from '@entities/cities/hooks'
import { useShipment } from '@entities/shipment/model'
import { useOpenStockSelectorWithBasketItems, useToggleCitySelector } from 'src/features/shipment-selector/hooks'
import { useIsBasketModalErecipe, useToggleBasketModalErecipe } from '@entities/prescription/hooks'
import { ModalPrescriptionDesktop } from '@entities/prescription/ui/prescription-enter-form-desktop'
import { useUnit } from 'effector-react'
import { $authForPage } from 'src/features/authorize/start'

const Navbar = () => {
    const router = useRouter()
    const shipment = useShipment()
    const toggleCitySelector = useToggleCitySelector()
    const isBasketModalErecipe = useIsBasketModalErecipe()
    const toggleModalErecipe = useToggleBasketModalErecipe()
    const authForPage = useUnit($authForPage)
    const openStockSelectorWithBasketItems = useOpenStockSelectorWithBasketItems()
    const city = useCityById(shipment.cityId)
    const authorizeContext = useContext(AuthorizeContext)

    const clickAccountHandler = async () => {
        const isAuthorization = await customerApi.checkAuthorization()
        if (isAuthorization) {
            await router.push('/account/history')
        } else {
            authorizeContext.toggleIsOpen(true)
        }
    }

    return (
        <S.Container>
            <S.NavBar>
                <S.NavItem onClick={toggleCitySelector}>
                    <GeoSmall />
                    {city?.title || 'Выберите регион'}
                </S.NavItem>
                <S.NavItem data-stocks-show onClick={openStockSelectorWithBasketItems}>
                    Адреса аптек
                </S.NavItem>
                <Link href="/condition/delivery" passHref legacyBehavior>
                    <S.NavItem>Доставка</S.NavItem>
                </Link>
                <S.NavItem data-erecipe-show onClick={() => toggleModalErecipe(false)}>
                    Электронный рецепт
                </S.NavItem>
                <Link href="/condition/pickup" passHref legacyBehavior>
                    <S.NavItem>Самовывоз</S.NavItem>
                </Link>
                <Link href="/company/loyalty" legacyBehavior>
                    <S.NavItem>Программа лояльности</S.NavItem>
                </Link>
                <Link href="/contact/feedback" passHref legacyBehavior>
                    <S.NavItem>Обратная связь</S.NavItem>
                </Link>
            </S.NavBar>
            <S.NavBar>
                <S.NavItem onClick={clickAccountHandler}>
                    <S.UserImage /> Личный кабинет
                </S.NavItem>
            </S.NavBar>
            <ModalPrescriptionDesktop cancelHandler={toggleModalErecipe} isOpened={isBasketModalErecipe} />
            {authorizeContext.isOpen && <ModalAuthorize closeHandler={authorizeContext.toggleIsOpen} />}
        </S.Container>
    )
}

export default Navbar
